import { SxProps, Theme } from '@mui/material';

export const DpContentCardSX = (example: boolean): SxProps<Theme> => ({
	position: example ? '' : 'fixed',
	bottom: '5px',
	left: '25px',
	zIndex: 1000,
	width: example ? '100%' : '230px',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	backgroundColor: 'transparent',
	padding: 0,
	'@media (max-width: 768px)': {
		bottom: '5px',
		left: '10px',
		width: '230px',
	},
});

export const DpLinkSX: SxProps<Theme> = {
	width: '100%',
	height: '100%',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
};

export const DpImageSX: SxProps<Theme> = {
	width: '230px',
	borderRadius: '8px',
};

export const DpHiddenSX: SxProps<Theme> = {
	display: 'none',
};

export const DpCerrarSX: SxProps<Theme> = {
	position: 'absolute',
	top: '1px',
	right: '11px',
	width: '25px',
	height: '25px',
	borderRadius: '50%',
	backgroundColor: '#000',
	color: '#fff',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	cursor: 'pointer',
	padding: '5px',
	'@media (max-width: 768px)': {
		top: '5px',
		right: '15px',
		width: '20px',
		height: '20px',
	},
};
